export default __webpack_public_path__ + "static/media/pic3.bac861eb.jpg";